import { render } from "./AddReviewModal.vue?vue&type=template&id=b8084282&scoped=true"
import script from "./AddReviewModal.vue?vue&type=script&lang=js"
export * from "./AddReviewModal.vue?vue&type=script&lang=js"

import "./AddReviewModal.vue?vue&type=style&index=0&id=b8084282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8084282"]])

export default __exports__